import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import { BrowserRouter as Router } from 'react-router-dom'
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'
import createLogger from 'redux-logger'
import App from './components/App'

const defaultState = {
  courses: {},
}

export const rootReducer = (state = defaultState, action) => {
  switch (action.type) {
    default:
      return state
  }
}

const middlewares =
  process.env.NODE_ENV === 'production'
    ? applyMiddleware(thunk)
    : applyMiddleware(thunk, createLogger())
let appStore = compose(middlewares)(createStore)(rootReducer)

export let startCheckoutApp = () => {
  ReactDOM.render(
    <Router>
      <Provider store={appStore}>
        <App />
      </Provider>
    </Router>,
    document.getElementById('app')
  )
}
